import React from 'react';
import { MultiSelect, Option } from '../../../../../../../components/ui/multi-select';
import { CollapsibleFilterBar } from './CollapsibleFilterBar';

// Coating-specific filter constants
const COATING_STATUS_TYPES = ['Available', 'Consumed'] as const;

interface CoatingFilters {
  status: string[];
  lotNumber: string[];
  manufacturer: string[];
  batchNumber: string[];
}

interface CoatingFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filters: CoatingFilters;
  onFilterChange: (key: keyof CoatingFilters) => (value: string[]) => void;
  uniqueLotNumbers: string[];
  uniqueManufacturers: string[];
  uniqueBatchNumbers: string[];
  hasActiveFilters: boolean;
  filteredCount: number;
  onResetFilters: () => void;
}

export const CoatingFilters: React.FC<CoatingFiltersProps> = ({
  searchQuery,
  onSearchChange,
  filters,
  onFilterChange,
  uniqueLotNumbers,
  uniqueManufacturers,
  uniqueBatchNumbers,
  hasActiveFilters,
  filteredCount,
  onResetFilters,
}) => {
  // Convert arrays to options for MultiSelect
  const statusOptions: Option[] = COATING_STATUS_TYPES.map(status => ({
    value: status,
    label: status
  }));

  const lotNumberOptions: Option[] = uniqueLotNumbers.map(lotNumber => ({
    value: lotNumber,
    label: lotNumber
  }));

  const manufacturerOptions: Option[] = uniqueManufacturers.map(manufacturer => ({
    value: manufacturer,
    label: manufacturer
  }));

  const batchNumberOptions: Option[] = uniqueBatchNumbers.map(batchNumber => ({
    value: batchNumber,
    label: batchNumber
  }));

  const activeFilterCount =
    filters.status.length +
    filters.lotNumber.length +
    filters.manufacturer.length +
    filters.batchNumber.length;

  return (
    <CollapsibleFilterBar
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search materials by lot number, manufacturer, or details..."
      activeFilterCount={activeFilterCount}
      filteredCount={filteredCount}
      filteredCountLabel="materials"
      onResetFilters={onResetFilters}
    >
      <MultiSelect
        options={statusOptions}
        selected={filters.status}
        onChange={onFilterChange('status')}
        placeholder="Status"
        isSearchable={false}
      />
      <MultiSelect
        options={lotNumberOptions}
        selected={filters.lotNumber}
        onChange={onFilterChange('lotNumber')}
        placeholder="Lot Number"
      />
      <MultiSelect
        options={manufacturerOptions}
        selected={filters.manufacturer}
        onChange={onFilterChange('manufacturer')}
        placeholder="Manufacturer"
      />
      <MultiSelect
        options={batchNumberOptions}
        selected={filters.batchNumber}
        onChange={onFilterChange('batchNumber')}
        placeholder="Batch Number"
      />
    </CollapsibleFilterBar>
  );
}; 